<template>
  <div class="searcher">
    <div class="searcher__item search">
      <div class="search__wrap">
        <md-icon md-src="/static/img/search.svg" class="search__icon"/>
        <input-field
          v-model="filters.name"
          @focus="activeInput = true"
          @blur="filters.name === '' ? activeInput = false : ''"
          @keyup="emitSearchEvent()"
          class="search__input"
          name="token-name"
          :placeholder="i18n.lbl_search_campaign()"
        />
        <md-icon v-if="filters.name !== ''"
                 md-src="/static/img/close_icon.svg"
                 @click.native="filters.name = ''; emitSearchEvent()"
                 class="search__clear"
        />
      </div>
      <md-button v-if="activeInput"
                 @click="emitSearchEvent()"
                 class="btn md-primary"
      >{{ i18n.lbl_search_btn() }}</md-button>
    </div>
    <div v-if="!activeInput" class="searcher__item">
      <select-field
        v-model="filters.type"
        class="search__filter"
        :label="i18n.sale_type_fund()"
        :values="fundTypes"
      />
    </div>
    <div v-if="!activeInput" class="searcher__item">
      <select-field
        v-model="filters.state"
        class="search__filter"
        :label="i18n.lbl_campaign_status()"
        :values="states"
      />
    </div>
    <div v-if="!activeInput" class="searcher__item">
      <select-field
        v-model="filters.sortBy"
        class="search__filter"
        :label="i18n.lbl_sort_by()"
        :values="sortTypes"
      />
    </div>
  </div>
</template>

<script>
  import InputField from '@com/fields/InputField'
  import SelectField from '@com/fields/SelectField'
  import { i18n } from '@js/i18n'
  import { commonEvents } from '@js/events/common_events'
  import debounce from 'lodash/debounce'
  import { saleTypes, saleSortTypes, saleStates } from '@const'

  export default {
    name: 'searcher',

    components: {
      InputField,
      SelectField
    },

    props: [],

    data () {
      return {
        filters: {
          name: '',
          type: saleTypes.all.str,
          state: saleStates.all.str,
          sortBy: saleSortTypes.created.str
        },
        eventEmitter: null,
        i18n,
        fundTypes: Object.values(saleTypes).map(type => type.str),
        states: Object.values(saleStates).map(state => state.str),
        sortTypes: Object.values(saleSortTypes).map(type => type.str),
        activeInput: false
      }
    },

    methods: {
      debounceSearchEvent () {
        if (!this.eventEmitter) {
          this.eventEmitter = debounce(() => this.$emit(commonEvents.searchInputEvent, this.composeFilters()), 450)
        }
        return this.eventEmitter()
      },
      emitSearchEvent () {
        this.$emit(commonEvents.searchInputEvent, this.composeFilters(), this.filters.type.toLowerCase())
        this.activeInput = false
      },
      composeFilters () {
        const filters = {
          name: this.filters.name.toUpperCase(),
          type: Object.values(saleTypes).find(type => type.str === this.filters.type),
          state: Object.values(saleStates).find(state => state.str === this.filters.state),
          sortBy: Object.values(saleSortTypes).find(type => type.str === this.filters.sortBy)
        }
        return filters
      }
    },

    watch: {
      // 'filters.token': function () { this.debounceSearchEvent() },
      'filters.type': function () { this.emitSearchEvent() },
      'filters.state': function () { this.emitSearchEvent() },
      'filters.sortBy': function () { this.emitSearchEvent() }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~scss/variables';
  @import '~scss/mixins';

  .searcher {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    flex: 1 1 auto;

    @include respond-to(large) {
      width: 100%;
    }

    @include respond-to(medium) {
      flex-direction: column;
      align-items: flex-start;
    }

    &__item {
      flex: 1 1 auto;

      &:not(:first-child) {
        flex: 0 0 180px;
        margin-left: 16px;

        @include respond-to(medium) {
          flex: unset;
          width: 100%;
          margin-left: 0;
        }
      }
    }

    .search {
      position: relative;
      display: flex;
      flex-grow: 3;
      align-items: center;
      justify-content: space-between;
      height: 100%;

      @include respond-to(medium) {
        width: 100%;
      }

      &__wrap {
        position: relative;
        flex: 1 1 auto;
      }

      &__input {
       flex: 1 1 auto;
        & /deep/ input {
          padding-left: 24px;
        }
      }

      &__icon {
        position: absolute;
        top: 30px;
        left: 12px;

        & /deep/ svg {
          width: 16px;
        }
      }

      & .btn {
        margin-left: 32px;
        @include respond-to(medium) {
          margin-left: 12px;
        }
      }

      &__clear {
        position: absolute;
        top: 30px;
        right: 4px;
        cursor: pointer;

        & /deep/ svg {
          width: 14px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/vue/app/sales/overview/Sales.Searcher.vue